export const PRIORITIES = {
  low: { label: "Baja", color: "#34D399" },
  medium: { label: "Media", color: "#FBBF24" },
  high: { label: "Alta", color: "#F87171" },
  urgent: { label: "Urgente", color: "#FF1744" },
};

export const LABEL_COLORS = ["#FF3B30", "#00B0FF", "#00E676", "#FFD600", "#AB47BC", "#FF6D00", "#26C6DA", "#EC407A"];

export function statusRule(columns = [], fromId, toId) {
  const t = (id) => (columns.find((c) => c.id === id)?.title || "").toLowerCase();
  const from = t(fromId), to = t(toId);
  if (!from || !to || fromId === toId) return null;
  if (to.startsWith("plane") && !from.startsWith("plane")) return "block-back";
  if (from.startsWith("plane") && (to.includes("progreso") || to.includes("proceso"))) return "confirm-start";
  return null;
}

export function dueState(due, done = false) {
  if (!due || done) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(due.slice(0, 10) + "T00:00:00");
  const diff = Math.round((d - today) / 86400000);
  if (diff < 0) return "overdue";
  if (diff <= 2) return "soon";
  return null;
}

export function initials(name = "") {
  return name.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
}

export function Avatar({ user, size = 28, className = "" }) {
  if (!user) return null;
  return (
    <div
      className={`flex items-center justify-center rounded-full font-bold text-black shrink-0 ${className}`}
      style={{ width: size, height: size, background: user.avatar_color || "#FF3B30", fontSize: size * 0.4 }}
      title={user.name}
      data-testid={`avatar-${user.id}`}
    >
      {initials(user.name)}
    </div>
  );
}
